import React, { Component } from 'react';

import Collapsible from 'react-collapsible';
import { connect } from 'react-redux';

import CompanyPreferencesForm from './CompanyPreferencesFrom';
import UserPreferencesForm from './UserPreferencesForm';
import UserShowingsForm from './UserShowingsForm';

import { getCompanyPreferences, updateCompanyPreferences } from 'actions/companyDetailsActions';
import * as userTypesActions from 'actions/userTypesActions';

import MenuHeader from 'components/shared/MenuHeader';

import { hostIsCapreit } from 'helpers/CurrentWindowLocation';
import { getTranslatedString } from 'helpers/i18n';

const DO_NOT_DISPLAY = 0;

export default connect(
  store => {
    return {
      userPreferences: store.userTypes.userPreferences,
      userType: store.userTypes.userType,
      userId: store.userTypes.userId,
      companyPreferences: store.companyDetails.companyPreferences,
      userPermissions: store.userTypes.permissions,
      availability: store.userTypes.availability,
      showAvailabilitiesForm: store.userTypes.showAvailability,
      admin: store.userTypes.admin,
    };
  },
  { ...userTypesActions, getCompanyPreferences, updateCompanyPreferences }
)(
  class UserPreferences extends Component {
    constructor(props) {
      super(props);
      this.state = {
        option1Open: false,
        option2Open: false,
        option3Open: false,
        option4Open: false,
      };
    }

    UNSAFE_componentWillMount = () => {
      this.props.getUserPreferences();
      if (this.props.userType === 'agent') {
        this.props.getUserAvailability();
        this.props.getCompanyPreferences();
      }
    };

    handleSubmit = formData => {
      this.props.updateUserPreferences(formData);
    };

    submitCompanyPreferences = formData => {
      this.props.updateCompanyPreferences(formData);
    };

    handleAvailabilitySubmit = formData => {
      this.props.updateUserAvailability(this.props.userType, this.props.userId, formData);
    };

    displayCompanyPreferences = () => {
      if (this.props.userPermissions.company_settings === DO_NOT_DISPLAY) {
        return null;
      }

      if (this.props.userType !== 'agent' || this.props.admin !== true) {
        return null;
      }

      return (
        <div className="row">
          <Collapsible
            style={{ cursor: 'pointer' }}
            trigger={
              <MenuHeader
                menuTitle={getTranslatedString(
                  'landlordPortal.userPreferences.menuTitle.companyPreferences'
                )}
                isOpen={this.state.option2Open}
              />
            }
            onOpening={() => this.setState({ option2Open: true })}
            onClosing={() => this.setState({ option2Open: false })}
          >
            <CompanyPreferencesForm
              onSubmit={this.submitCompanyPreferences}
              automationSettings={this.props.companyPreferences}
            />
          </Collapsible>
        </div>
      );
    };

    displayShowingsPreferences = () => {
      if (this.props.userType !== 'agent' || hostIsCapreit()) {
        return null;
      }

      return (
        <div className="row">
          <Collapsible
            trigger={
              <MenuHeader
                menuTitle={getTranslatedString(
                  'landlordPortal.userPreferences.menuTitle.userShowingAvailability'
                )}
                isOpen={this.state.option3Open}
              />
            }
            style={{ cursor: 'pointer' }}
            onOpening={() => this.setState({ option3Open: true })}
            onClosing={() => this.setState({ option3Open: false })}
          >
            <UserShowingsForm
              submitAvailability={this.handleAvailabilitySubmit}
              availability={this.props.availability}
              showGoogleCal
              showAvailabilitiesForm={this.props.showAvailabilitiesForm}
            />
          </Collapsible>
        </div>
      );
    };

    displayUserPreferences = () => {
      if (this.props.userType !== 'agent') {
        return null;
      }

      return (
        <div className="row">
          <Collapsible
            trigger={
              <MenuHeader
                menuTitle={getTranslatedString(
                  'landlordPortal.userPreferences.menuTitle.userPreferences'
                )}
                isOpen={this.state.option1Open}
              />
            }
            style={{ cursor: 'pointer' }}
            onOpening={() => this.setState({ option1Open: true })}
            onClosing={() => this.setState({ option1Open: false })}
          >
            <UserPreferencesForm
              onSubmit={this.handleSubmit.bind(this)}
              payment_reminders={this.props.userPreferences.payment_reminders}
              renewal_reminders={this.props.userPreferences.renewal_reminders}
              userType={this.props.userType}
            />
          </Collapsible>
        </div>
      );
    };

    render() {
      return (
        <div className="body" role="main">
          <div className="centers" style={{ overflow: 'scroll' }}>
            <div style={{ marginBottom: '50px' }}>
              <div style={{ maxWidth: '720px', margin: '10px auto' }}>
                <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                  <span className="page-title">
                    {this.props.userType === 'agent'
                      ? getTranslatedString('landlordPortal.userPreferences.automation')
                      : getTranslatedString('landlordPortal.userPreferences.preferences')}
                  </span>
                </div>
                {this.displayUserPreferences()}
                {this.displayCompanyPreferences()}
                {this.displayShowingsPreferences()}
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
);
